module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00415.aa37db0c.jpg";